export default function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
  const { item, html, components } = templateOptions;
  const hitImage = algoliaShopify.helpers.renderImage(item, 250);

  const price = item.price || 0;
  const compareAtPrice = item.compare_at_price || 0;

  let discountBadge = '';
  if (compareAtPrice > price) {
    const discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
    discountBadge = html`
      <div class="aa-item-discount-badge absolute">
        <div class="aa-item-discount-badge__label">-${discount}%</div>
      </div>
    `;
  }

  return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-item--picture_wrapper relative">
          ${discountBadge}
          <img
            class="aa-item--picture"
            src="${hitImage.src}"
            srcset="${hitImage.srcset}"
            sizes="${hitImage.sizes}"
            alt="${item.title} - ${item.variant_title}"
          />
        </div>

        <div class="ais-hit--details">
          <p
            class="aa-item--subtitle bls__product-vendor"
            title="${item.product_type}${algoliaShopify.translation_helpers.by(item.vendor)}"
          >
            ${item.vendor}
          </p>
          <p class="aa-item--title">
            <a
              href="${itemLink}"
              title="${algoliaShopify.helpers.fullTitle(item.title, item._distinct, item.variant_title)}"
            >
              ${item.title}
            </a>
          </p>
          <p class="aa-item--price bls__product-price">
            <span class="price special-price">${algoliaShopify.helpers.displayPrice(item, item._distinct)}</span>
            ${!item._distinct && item.compare_at_price > item.price &&
              html`
                <span class="aa-item--price-striked">
                  <span>
                    ${algoliaShopify.helpers.displayStrikedPrice(item.price, item.compare_at_price)}
                  </span>
                </span>
              `}
          </p>
        </div>
      </div>
    </a>
  `;
}
